// frontend/src/pages/ShopMedicines.js
import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";

export default function ShopMedicines() {
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const fileInputs = useRef({});
const [suggestions, setSuggestions] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
const [loading, setLoading] = useState(false);
  const role = localStorage.getItem("userRole");
const [page, setPage] = useState(1);
const [hasMore, setHasMore] = useState(true);
  useEffect(() => {
    fetchItems();
  }, []);
useEffect(() => {
  function handleScroll() {
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 100 &&
      hasMore
    ) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchItems(nextPage);
    }
  }

  window.addEventListener("scroll", handleScroll);

  return () => window.removeEventListener("scroll", handleScroll);
}, [page, hasMore]);

useEffect(() => {
  const delay = setTimeout(() => {
    setPage(1);              // 🔥 ADD THIS
    fetchItems(1, search);
  }, 400);

  return () => clearTimeout(delay);
}, [search]);
  // ---------------- FETCH MEDICINES ----------------


async function fetchItems(pageNum = 1, searchTerm = "") {
  if (loading) return;
  setLoading(true);

  try {
    const res = await axiosInstance.get(
      `/medicine/list/?page=${pageNum}&search=${searchTerm}`
    );

    const data = Array.isArray(res.data)
      ? res.data
      : res.data.results || [];

    if (pageNum === 1) {
      setItems(data);
      setSelectedIds([]);
      setSelectAll(false);
    } else {
      setItems(prev => [...prev, ...data]);
    }

    setHasMore(!!res.data.next);

  } catch {
    alert("Failed to load medicines");
  }

  setLoading(false);
}


useEffect(() => {
  if (!search) {
    setSuggestions([]);
    return;
  }

  const delay = setTimeout(async () => {
    try {
      const res = await axiosInstance.get(
  `/medicine/suggestions/?q=${search}`
);

      setSuggestions(res.data);
    } catch (err) {
      console.log(err);
    }
  }, 300);

  return () => clearTimeout(delay);
}, [search]);




  // ---------------- DELETE SINGLE MEDICINE ----------------
async function handleDelete(id) {
  if (!window.confirm("Are you sure to delete this medicine?")) return;

  try {
    await axiosInstance.delete(`/delete_medicine/${id}/`);

    // 🔥 no refetch
    setItems(prev => prev.filter(item => item.id !== id));
    setSelectedIds(prev => prev.filter(x => x !== id));

  } catch {
    alert("Delete failed");
  }
}

  // ---------------- IMAGE UPLOAD -------------------
  const handleImageChange = async (e, id) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
    formData.append("images", files[i]);
  }

    try {
      await axiosInstance.post(`/update_medicine_image/${id}/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      fetchItems();
    } catch (err) {
console.log(err.response?.data || err);
      alert("Image upload failed");
    }
  };

  // ---------------- FILTERED DATA -------------------
const filtered = items;

  const imageUrl = (img) =>
    img ? (img.startsWith("http") ? img : `http://127.0.0.1:8000${img}`) : null;

  // ---------------- CHECKBOX HELPERS ----------------
  const toggleSelect = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((x) => x !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const toggleSelectAll = () => {
    if (!selectAll) {
      const allVisibleIds = filtered.map((m) => m.id);
      setSelectedIds(allVisibleIds);
    } else {
      setSelectedIds([]);
    }
    setSelectAll(!selectAll);
  };

  // ---------------- BULK DELETE ----------------
  const handleDeleteSelected = async () => {
    if (selectedIds.length === 0) {
      alert("No medicines selected");
      return;
    }

    if (!window.confirm("Delete selected medicines?")) return;

    try {
      await axiosInstance.post("/medicine/bulk-delete/", { ids: selectedIds });
      alert("Selected medicines deleted");
      fetchItems();
    } catch (err) {
      console.error(err);
      alert("Failed to delete selected medicines");
    }
  };

  const handleDeleteAll = async () => {
    if (!window.confirm("Delete ALL medicines?")) return;

    try {
      await axiosInstance.delete("/medicine/delete-all/");
      alert("All medicines deleted");
      fetchItems();
    } catch (err) {
      console.error(err);
      alert("Failed to delete all medicines");
    }
  };

  // ---------------- RENDER PAGE --------------------
  return (
    <div style={{ padding: 20 }}>
      {/* BACK BUTTON + ADD MEDICINE */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 15,
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            background: "#ddd",
            padding: "8px 15px",
            borderRadius: 6,
            border: "none",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          ← Back
        </button>

        {role === "admin" && (
          <button
            onClick={() => navigate("/add-medicine")}
            style={{
              background: "green",
              color: "#fff",
              padding: "10px 16px",
              borderRadius: 8,
              border: "none",
              fontWeight: 700,
            }}
          >
            + Add Medicine
          </button>
        )}
      </div>

      {/* SEARCH BOX */}
      <input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search medicine..."
        style={{
          width: "100%",
          padding: 10,
          borderRadius: 8,
          border: "1px solid #ccc",
          marginBottom: 15,
        }}
      />


{suggestions.length > 0 && (
  <div style={{
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: 10,
    marginTop: 5
  }}>
    {suggestions.map((item) => (
      <div
        key={item}
        style={{ padding: 10, cursor: "pointer" }}
        onClick={() => {
          setSearch(item.name);
          setSuggestions([]);
        }}
      >
        <div style={{ fontWeight: 600 }}>{item.name}</div>
        <div style={{ fontSize: 12, color: "#666" }}>
          {item.salt_composition}
        </div>
      </div>
    ))}
  </div>
)}


      {/* ADMIN BULK ACTIONS */}
      {role === "admin" && (
        <div style={{ marginBottom: 15, display: "flex", gap: 10 }}>
          <label>
            <input
              type="checkbox"
              checked={selectAll}
              onChange={toggleSelectAll}
              style={{ marginRight: 6 }}
            />
            Select All (visible)
          </label>

          <button
            onClick={handleDeleteSelected}
            style={{
              background: "orange",
              color: "#fff",
              padding: "6px 12px",
              borderRadius: 6,
              border: "none",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Delete Selected
          </button>

          <button
            onClick={handleDeleteAll}
            style={{
              background: "red",
              color: "#fff",
              padding: "6px 12px",
              borderRadius: 6,
              border: "none",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Delete ALL
          </button>
        </div>
      )}

      {/* GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
          gap: 20,
        }}
      >
        {filtered.map((m) => {
          const sellingPrice = m.selling_price ?? m.price ?? 0;
          const mrp = m.mrp ?? m.price ?? 0;
          const discount =
            mrp && sellingPrice
              ? Math.round(((mrp - sellingPrice) / mrp) * 100)
              : 0;

          return (
            <div
              key={m.id}
              style={{
                border: "1px solid #eee",
                padding: 14,
                borderRadius: 10,
                background: "#fff",
              }}
            >
              {/* ADMIN SELECT CHECKBOX */}
              {role === "admin" && (
                <div style={{ marginBottom: 6, textAlign: "left" }}>
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(m.id)}
                    onChange={() => toggleSelect(m.id)}
                  />{" "}
                  <span style={{ fontSize: 12 }}>Select</span>
                </div>
              )}

              {/* IMAGE + CLICK TO UPLOAD */}
              <div
                style={{
                  width: "100%",
                  height: 150,
                  background: "#f3f3f3",
                  borderRadius: 8,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  overflow: "hidden",
                }}
                onClick={() =>
                  fileInputs.current[m.id] && fileInputs.current[m.id].click()
                }
              >
                {m.images && m.images.length > 0 ? (
  <div
    style={{
      display: "flex",
      gap: 8,
      overflowX: "auto",
      width: "100%",
      height: "100%",
      padding: 6,
    }}
  >
    {m.images.map((img, index) => (
      <div
        key={index}
        style={{
          position: "relative",
          minWidth: 120,
          height: "100%",
          borderRadius: 8,
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        <img
          src={img}
          alt={m.name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />

        {/* DELETE BUTTON */}
        <button
          onClick={async (e) => {
            e.stopPropagation();

            try {
              await axiosInstance.post(
                `/delete_medicine_image/${m.id}/`,
                { image: img }
              );

              fetchItems();

            } catch (err) {
              alert("Delete failed");
            }
          }}
          style={{
            position: "absolute",
            top: 5,
            right: 5,
            width: 24,
            height: 24,
            borderRadius: "50%",
            border: "none",
            background: "red",
            color: "#fff",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          ×
        </button>
      </div>
    ))}
  </div>
) : m.image ? (

  <div
    style={{
      position: "relative",
      width: "100%",
      height: "100%",
    }}
  >

    <img
      src={m.image}
      alt={m.name}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        cursor: "pointer",
      }}
    />

    <button
      onClick={async (e) => {
        e.stopPropagation();

        try {

          await axiosInstance.post(
            `/delete_medicine_image/${m.id}/`,
            { image: m.image }
          );

          fetchItems();

        } catch (err) {
          alert("Delete failed");
        }
      }}
      style={{
        position: "absolute",
        top: 5,
        right: 5,
        width: 24,
        height: 24,
        borderRadius: "50%",
        border: "none",
        background: "red",
        color: "#fff",
        cursor: "pointer",
        fontWeight: "bold",
      }}
    >
      ×
    </button>

  </div>
) : (
  <span style={{ color: "#888" }}>No Image</span>
)}
              </div>

              <input
  type="file"
  multiple
  name="images"
  accept="image/*"
  ref={(el) => (fileInputs.current[m.id] = el)}
  style={{ display: "none" }}
  onChange={(e) => handleImageChange(e, m.id)}
/>

              {/* TITLE */}
              <h4 style={{ marginTop: 10 }}>{m.name}</h4>
              <p style={{ color: "#777" }}>
                {m.company} | {m.type}
              </p>

              {/* PRICE */}
              <div style={{ textAlign: "center", marginTop: 10 }}>
                <div>
                  <del style={{ color: "red" }}>{mrp ? `₹${mrp}` : ""}</del>
                </div>
                <div
                  style={{
                    fontSize: 18,
                    color: "green",
                    fontWeight: 700,
                  }}
                >
                  ₹{sellingPrice}
                </div>
                {discount > 0 && (
                  <div style={{ color: "orange", fontWeight: 700 }}>
                    {discount}% OFF
                  </div>
                )}
              </div>

              {/* ADMIN BUTTONS */}
              {role === "admin" && (
                <div style={{ marginTop: 12 }}>
                  <button
                    onClick={() => navigate(`/admin/medicine?id=${m.id}`)}
                    style={{
                      width: "100%",
                      background: "#0284C7",
                      color: "#fff",
                      padding: 8,
                      borderRadius: 6,
                      border: "none",
                      fontWeight: 700,
                      marginBottom: 8,
                    }}
                  >
                    Edit Details
                  </button>

                  <button
                    onClick={() => handleDelete(m.id)}
                    style={{
                      width: "100%",
                      background: "red",
                      color: "#fff",
                      padding: 8,
                      borderRadius: 6,
                      border: "none",
                      fontWeight: 700,
                    }}
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
